import styled from 'styled-components';
import vector from '../../../../assets/equipment/vector.svg';

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionLabel = styled.span`
  color: #999;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const StatusChip = styled.span<{ bg: string; color: string }>`
  background: ${(p) => p.bg};
  color: ${(p) => p.color};
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 100px;
  letter-spacing: 0.02em;
`;

export const NegadaAlert = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background: #fdecee;
  border: 1px solid #f5c2c7;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
  color: #c53030;
  line-height: 1.4;
`;

// Mesmo alerta visual do NegadaAlert, para avisos que não são sobre status de emissão.
export const AvisoAlert = styled(NegadaAlert)``;

export const AvisoPedidoAlterado = styled(AvisoAlert)`
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const TextoAviso = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  small {
    font-size: 11px;
    opacity: 0.85;
  }
`;

export const AvisoAcao = styled.button`
  background: transparent;
  border: 1px solid #c53030;
  border-radius: 6px;
  color: #c53030;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;

  &:hover {
    background: #fbd5d9;
  }
`;

export const AvisoTotais = styled(AvisoAlert)`
  margin-top: 12px;
`;

export const IpiCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
`;

export const OrigemIpiChip = styled.span<{ $semRegra?: boolean }>`
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 1px 6px;
  border-radius: 100px;
  background: ${(p) => (p.$semRegra ? '#fdecee' : '#ebebeb')};
  color: ${(p) => (p.$semRegra ? '#c53030' : '#999')};
`;

export const TotalLinha = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #0090d3;
  font-size: 18px;
  font-weight: 700;
`;

export const TotalValor = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const ComposicaoToggle = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid #ddd;
  border-radius: 50%;
  background: #fff;
  color: #696969;
  display: grid;
  place-items: center;
  cursor: pointer;

  svg {
    transition: transform 0.2s;
  }

  &[aria-expanded='true'] svg {
    transform: rotate(180deg);
  }
`;

export const Composicao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #e4e4e4;
  font-size: 12px;
  color: #696969;

  span:last-child {
    color: #303030;
    font-variant-numeric: tabular-nums;
  }
`;

export const ItensHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const ItensHeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const CenarioPill = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 1 380px;
  min-width: 0;
  height: 38px;
  padding-left: 14px;
  border: 1px solid #ddd;
  border-radius: 100px;
  background: #ebebeb;

  &:focus-within {
    border-color: #0090d3;
  }

  label {
    font-size: 11px;
    font-weight: 700;
    color: #696969;
    white-space: nowrap;
    margin: 0;
  }

  select {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: 0;
    padding: 0 40px 0 0;
    background: transparent url(${vector}) no-repeat right 15px center / 18px 9px;
    appearance: none;
    -webkit-appearance: none;
    font-size: 13px;
    color: #333;
    text-overflow: ellipsis;
    outline: none;
    cursor: pointer;
  }
`;

export const AddItemButton = styled.button`
  height: 38px;
  padding: 0 16px;
  border: 1px solid #0090d3;
  border-radius: 100px;
  background: #fff;
  color: #0090d3;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;

export const PersonalizadoChip = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #b06f07;
  background: #fbf1df;
  border-radius: 100px;
  padding: 1px 2px 1px 8px;

  button {
    border: 0;
    background: none;
    color: #b06f07;
    font-weight: 700;
    cursor: pointer;
    padding: 0 5px;
    line-height: 1;
  }
`;

export const SemCenarioAviso = styled.span`
  display: block;
  margin-top: 2px;
  font-size: 9px;
  line-height: 1.2;
  color: #c53030;
`;

export const ItensScroll = styled.div`
  overflow-x: auto;
`;

// Soma dos pisos de GRID_COLS (ItensSection) + 13 gaps + padding lateral: abaixo disso a grade corta os inputs.
export const ItensGrade = styled.div`
  min-width: 1020px;
`;

export const DeleteCell = styled.div`
  position: sticky;
  right: 0;
  z-index: 1;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-shadow: -8px 0 8px -8px rgba(0, 0, 0, 0.15);
`;

export const ColunaLateral = styled.div`
  position: sticky;
  top: 0;
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  scrollbar-width: thin;
`;

export const TituloComStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 20px;
`;

export const NegadaIcone = styled.span`
  font-weight: 700;
`;
